<script>
import PortraitPhoto from './PortraitPhoto';
import { escapeHtml } from '../helpers';

export default {
  name: 'ContributorPortrait',
  components: {
    PortraitPhoto
  },
  props: {
    prefix: String,
    portrait: Object,
    mode: { type: String, default: 'normal' },
    showRelatedAnswersLink: { type: Boolean, default: false }
  },
  methods: {
    onBioClick(event) {
      event.preventDefault();
      this.$store.dispatch('openOverlayPage', {
        component: 'ContributorPage',
        props: {
          slug: this.slug
        }
      });
    },
    onContactClick(event) {
      event.preventDefault();
      this.$store.dispatch('openOverlayPage', {
        component: 'ContactPage',
        props: {
          slug: this.slug
        }
      });
    }
  },
  computed: {
    name() {
      return this.portrait.title
        ? escapeHtml(this.portrait.title.rendered)
        : this.portrait.post_title;
    },
    slug() {
      return this.portrait.post_name
        ? this.portrait.post_name
        : this.portrait.slug;
    }
  }
};
</script>

<template>
  <article
    class="contributor-portrait"
    v-bind:class="['contributor-portrait--' + mode]"
  >
    <portrait-photo
      v-bind:photo="portrait.photo"
      v-bind:name="portrait.post_title"
      v-bind:slug="slug"
      v-bind:hasBio="portrait.bio ? true : false"
    />
    <div class="contributor-portrait__content">
      <h1 class="contributor-portrait__name">
        <span v-if="prefix">{{ prefix }} <br /></span>
        {{ name }}
      </h1>
      <h2 class="contributor-portrait__role">{{ portrait.role }}</h2>
      <a
        href="#"
        class="contributor-portrait__link-bio read-more"
        v-on:click="onBioClick($event)"
        v-if="portrait.bio"
        >{{ $t('contributorPortrait.aboutMe') }}</a
      >
      <a
        href="#"
        class="contributor-portrait__link-contact read-more"
        v-on:click="onContactClick($event)"
        v-if="portrait.email"
        >{{ $t('contributorPortrait.contactMe') }}</a
      >
      <router-link
        v-bind:to="$t('contributorQuestions.url') + '/' + portrait.post_name"
        class="contributor-portrait__link-answers read-more"
        v-if="showRelatedAnswersLink"
        >{{ $t('contributorPortrait.myAnswers') }}</router-link
      >
    </div>
  </article>
</template>

<style lang="scss" scoped>
.contributor-portrait {
  position: relative;
  display: flex;
  color: $color-secondary;
}

.contributor-portrait--overlay {
  color: $color-light;
}

.contributor-portrait__content {
  width: 100%;
  margin: 0 0 0 1.6rem;
  padding: 1.12rem 0 0 1.6rem;
  border-top: rgba($color-secondary, 0.4) solid 0.1rem;
}

.contributor-portrait--overlay .contributor-portrait__content {
  border-color: rgba($color-light, 0.4);
}

.contributor-portrait__name {
  margin: 0;
  font-size: 1.8rem;
  font-weight: normal;
  letter-spacing: 0.052rem;
}

.contributor-portrait__role {
  margin: -0.16rem 0 1.6rem;
  font-size: 1.5rem;
  font-weight: normal;
  letter-spacing: 0.052rem;
}

.contributor-portrait__link-bio,
.contributor-portrait__link-contact,
.contributor-portrait__link-answers {
  margin: 0.48rem 0;
  white-space: nowrap;
}

.contributor-portrait__link-bio:before {
  width: 1.4em;
  height: 1.4em;
  background: center url('~@/assets/images/ico-paperclip.svg') no-repeat;
  vertical-align: -29%;
}

.contributor-portrait--overlay .contributor-portrait__link-bio:before {
  background-image: url('~@/assets/images/ico-paperclip-light.svg');
}

.contributor-portrait__link-contact:before {
  width: 1.4em;
  height: 1.4em;
  background: center url('~@/assets/images/ico-contact.svg') no-repeat;
  vertical-align: -29%;
}

.contributor-portrait--overlay .contributor-portrait__link-contact:before {
  background-image: url('~@/assets/images/ico-contact-light.svg');
}

.contributor-portrait__link-answers:before {
  width: 1.4em;
  height: 1.4em;
  background: center url('~@/assets/images/ico-answers.svg') no-repeat;
  vertical-align: -29%;
}

.contributor-portrait--overlay .contributor-portrait__link-answers:before {
  background-image: url('~@/assets/images/ico-answers-light.svg');
}
</style>
